import { PaginatedDto, PaginatedQuery } from "@core/data/dto/paginated.dto";
import type { Nullable } from "@core/domain/types/nullable.type";
import { Nullish } from "@core/domain/types/nullish.type";
import { MedicalLeavePeriodDto } from "@entity/data/dto/employee/contracts/termination/medical-leave-period.dto";
import { MedicalLeaveSubtypeEnumDto } from "@entity/data/dto/employee/medical-leave-subtype.dto";
import { TerminationCategoryEnumDto } from "@entity/data/dto/employee/termination-category.dto";
import { TerminationReasonEnumDto } from "@entity/data/dto/employee/termination-reason.dto";
import { Type } from "class-transformer";
import {
    IsArray,
    IsDateString,
    IsEnum,
    IsNotEmpty,
    IsNumber,
    IsOptional,
    IsString,
    ValidateNested,
} from "class-validator";

export class ContractTerminationDto {
    @IsNumber()
    @IsNotEmpty()
    id!: number;

    @IsEnum(TerminationCategoryEnumDto)
    @IsNotEmpty()
    termination_category!: TerminationCategoryEnumDto;

    @IsDateString()
    @IsNotEmpty()
    start_date!: string;

    @IsDateString()
    @IsOptional()
    end_date!: Nullable<string>;

    @IsString()
    @IsNotEmpty()
    reason!: string;

    @IsEnum(TerminationReasonEnumDto)
    @IsOptional()
    type!: Nullable<TerminationReasonEnumDto>;

    @IsEnum(MedicalLeaveSubtypeEnumDto)
    @IsOptional()
    medical_leave_subtype!: Nullable<MedicalLeaveSubtypeEnumDto>;

    @IsString()
    @IsOptional()
    cost!: Nullable<string>;

    @IsString()
    @IsOptional()
    total_cost!: Nullable<string>;

    @IsNumber()
    @IsNotEmpty()
    contract!: number;

    @IsArray()
    @ValidateNested({ each: true })
    @Type(() => MedicalLeavePeriodDto)
    @IsOptional()
    medical_leave_periods!: MedicalLeavePeriodDto[];
}

export class ContractTerminationsDto extends PaginatedDto {
    @IsArray()
    @Type(() => ContractTerminationDto)
    results!: ContractTerminationDto[];
}

export type ContractTerminationQuery = PaginatedQuery & {
    employee?: Nullish<number>;
};
